import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { originSelector } from '../../../modules/selectors/vHostRequestLocation';
import { useLocation } from 'react-router-dom';
import { JsonLd } from 'react-schemaorg';
import { gtinToJsonLd } from '../../../helpers/productHelper';
import _ from 'lodash';
import { allSeasonOptions } from '../../../helpers/tiresHelper';

function getMetaData({ tireDetail, origin, pathname }) {
    const { images, selectedBezugsquelle, gtin, saison, bezeichnung, hersteller } = tireDetail;
    const { onlineVK, vk_preis: pickupPrice, artNummer } = selectedBezugsquelle;

    const name = `${hersteller} ${bezeichnung} – ${_.find(allSeasonOptions, { type: saison })?.label}`;

    const image = _.head(images);
    const gtinJsonLdData = gtinToJsonLd({ gtin });
    let sanitizedPathname = pathname;
    try {
        if (/^https?:\/\//i.test(sanitizedPathname)) {
            sanitizedPathname = new URL(sanitizedPathname).pathname;
        }
    } catch (e) {}
    sanitizedPathname = (sanitizedPathname || '')
        .replace(/https?:\/\/[^/]+/gi, '')
        .replace(/\/{2,}/g, '/')
        .replace(/^([^/])/, '/$1');
    const url = `${origin}${sanitizedPathname}`;

    const price = (onlineVK || pickupPrice)?.toFixed(2);
    return {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        sku: artNummer,
        image,
        name,
        // TODO: sync with tireHelper.transformTiresForGoogleMerchantFeed
        // description,
        brand: {
            '@type': 'Thing',
            name: hersteller,
        },
        offers: {
            '@type': 'Offer',
            url,
            itemCondition: 'http://schema.org/NewCondition',
            availability: `http://schema.org/InStock`,
            price,
            priceCurrency: 'EUR',
        },
        ...gtinJsonLdData,
    };
}

function TireDetailMeta({ tireDetail }) {
    const origin = useSelector(originSelector);
    const { pathname } = useLocation();

    const metaData = useMemo(() => {
        return getMetaData({ tireDetail, origin, pathname });
    }, [origin, pathname, tireDetail]);

    return <JsonLd item={metaData} />;
}
export default TireDetailMeta;
